import { useStore } from '../../store';
import { percent, price, units } from '../layout/formatters';

export const CapacityReport = () => {
  const r = useStore(s => s.toProductionCapacityReport());

  return (
    <table style={{ tableLayout: 'fixed', width: '100%' }}>
      <thead>
        <tr>
          <th style={{ width: '70%' }}></th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        {fields.map(f => (
          <tr key={f.id}>
            <th>{f.display}</th>
            <td>{Number.isNaN(r[f.id]) ? 'NaN' : f.format(r[f.id])}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const fields = [
  { id: 'standardCapacity', format: units, display: 'Standard Capacity' },
  {
    id: 'capacityImprovement',
    format: percent,
    display: 'Capacity Improvement',
  },
  {
    id: 'actualCapacity',
    format: units,
    display: 'Actual Capacity',
  },
];
